import api from '@core/services/api/_api';
import CustomerRecord from '@core/classes/Customer/CustomerRecord';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCustomerStore = defineStore('customer', () => {
	// State
	const customer = ref<CustomerRecord | null>(null);

	// Actions
	async function getCustomer(customerId: string) {
		try {
			const response = await api.customerPortal.getCustomerInformation(customerId);
			if (response?.status === 200 && response.data) {
				customer.value = new CustomerRecord(response.data.customer);
			}
		} catch (error) {
			console.error(error, 'Error retrieving customer information');
			clearCustomer();
		}
	}

	function clearCustomer() {
		customer.value = new CustomerRecord();
	}

	function setCustomer(newCustomer: any) {
		customer.value = new CustomerRecord(newCustomer);

		const customerPlainObject = JSON.parse(JSON.stringify(customer.value));
		localStorage.setItem('customerData', JSON.stringify(customerPlainObject));
	}

	return {
		customer,
		getCustomer,
		clearCustomer,
		setCustomer,
	};
});
